<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer005">
<h6 class="sigil_not_in_toc"><span class="pagebreak" id="pageix" title="ix"></span>Reformation Commentary on Scripture</h6>
<h2 id="sigil_toc_id_1">Project Staff<br/>
<br/></h2>
<p class="firstcenter"><i>Project Editor</i></p>
<p class="center">David W. McNutt</p>
<hr class="half"/>
<p class="firstcenter"><i>Managing Editor and Production Manager</i></p>
<p class="center">Benjamin M. McCoy</p>
<hr class="half"/>
<p class="firstcenter"><i>Copyeditor</i></p>
<p class="center">Jeffrey A. Reimer</p>
<hr class="half"/>
<p class="firstcenter"><i>Assistant Project Editor</i></p>
<p class="center">Todd R. Hains</p>
<hr class="half"/>
<p class="firstcenter"><i>Editorial and Research Assistants</i></p>
<p class="center">David J. Hooper</p>
<p class="firstcenter">Ethan McCarthy</p>
<hr class="half"/>
<p class="firstcenter"><i>Assistants to the General Editors</i></p>
<p class="center">Le-Ann Little</p>
<p class="center">Jason Odom</p>
<hr class="half"/>
<p class="firstcenter"><i>Design</i></p>
<p class="center">Cindy Kiple</p>
<hr class="half"/>
<p class="firstcenter"><i>Design Assistant</i></p>
<p class="center">Beth McGill</p>
<hr class="half"/>
<p class="firstcenter"><i>Content Production</i></p>
<p class="center">Richard M. Chung</p>
<p class="center">Maureen G. Tobey</p>
<p class="center">Daniel van Loon</p>
<p class="center">Jeanna L. Wiggins</p>
<hr class="half"/>
<p class="firstcenter"><i>Proofreader</i></p>
<p class="center">Travis Ables</p>
<hr class="half"/>
<p class="firstcenter"><i>Print Coordinator</i></p>
<p class="center">Jim Erhart</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// credits.vue?3a28bd4a